import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { requisitosPassword } from '@/components/utils/password';

export default function PasswordRequisitos({ password }: { password: string }) {
  const { t } = useTranslation();
  if (!password) return null;

  return (
    <ul className="mt-2 space-y-1">
      {requisitosPassword(password, t).map((r, i) => (
        <li
          key={i}
          className={`flex items-center gap-1.5 text-xs transition-colors ${
            r.ok
              ? 'text-[#288E7F] dark:text-[#4fb8a3]'
              : 'text-gray-400 dark:text-white/40'
          }`}
        >
          <span
            className={`w-3.5 h-3.5 rounded-full flex items-center justify-center shrink-0 border transition-colors ${
              r.ok
                ? 'bg-[#288E7F] border-[#288E7F] dark:bg-[#4fb8a3] dark:border-[#4fb8a3]'
                : 'border-gray-300 dark:border-white/20'
            }`}
          >
            {r.ok && <Check className="w-2.5 h-2.5 text-white" strokeWidth={3} />}
          </span>
          {r.label}
        </li>
      ))}
    </ul>
  );
}